import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import env from '@/utils/env'
import ErrorCatch from '../services/error-catch'

Vue.use(VueI18n)

console.log(env)
// const resourceLink = env === 'dev' ? '//10.60.196.244' : window.location.origin
// const resourceLink = env === 'dev' ? 'https://admin-pre.renderbus.com' : window.location.origin
// 由于 10.60.196.244 （root/Rayvision@2016）服务磁盘经常爆满导致语言包无法上传到服务，因此开发时使用的是测试环境的语言包。这并不会影响线上的语言包环境
const defaultLang = window.location.hostname.includes('renderbus') ? 'cn' : 'en'

const i18n = new VueI18n({
  locale: defaultLang, // set locale
  fallbackLocale: defaultLang,
})

const lang = localStorage.getItem('lang')
let isInit = false

if (lang) {
  i18n.locale = lang
} else {
  localStorage.setItem('lang', i18n.locale)
}

// 初始化饿了么组件的国际化
i18n.setLocaleMessage('cn', cnLocale)
i18n.setLocaleMessage('en', enLocale)

// 已加载模块数组
let modulesList = []
// 初始化需要加载的模块个
const initModuls = ['common', 'api', 'home', 'user-permission', 'user', 'task']

async function loadLanguageAsync(lang, modules) {
  if (!isInit) await initLoad()
  // TODO: 如果需要支持IE需要封装一套XHR规则
  return new Promise((resolve, reject) => {
    const moduleName = `${modules}-${lang}`
    if (modulesList.includes(moduleName)) return resolve()
    import(`@/locales/${modules}/${moduleName}.json`)
      .then(msg => {
        modulesList.push(moduleName)
        const LocalMessage = Object.assign(i18n.getLocaleMessage(lang), msg)
        i18n.setLocaleMessage(lang, LocalMessage)
        resolve()
      })
      .catch(e => {
        ErrorCatch.reloadPage()
        resolve()
      })
  })
}

// 初始化加载模块
function initLoad() {
  return new Promise((resolve, reject) => {
    isInit = true
    // 初始化加载公用模块
    initModuls.reduce(async (prev, cur) => {
      if (typeof prev === 'string') await loadLanguageAsync(i18n.locale, prev)
      await loadLanguageAsync(i18n.locale, cur)
      return cur
    })
    return resolve()
  })
}

//  国际化element-ui
ElementLocale.i18n((key, value) => i18n.t(key, value))

export { i18n, loadLanguageAsync }
